










import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import YieldBoxPlot from "./YieldBoxPlot.vue";
import * as services from "@/services/analyses";
import { Analysis } from "@/api/analyses/types";

@Component({
  name: "YieldBoxPlotController",
  components: {
    YieldBoxPlot,
  },
})
export default class YieldBoxPlotController extends Vue {
  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  @Prop({ type: String, required: true })
  private harvestSeason!: string;

  @Prop({ type: String, required: true })
  private cropType!: string;

  private async created() {
    await this.loadChart();
  }

  private async loadChart() {
    this.$emit('update:loading', true);
    try {
      await services.findYieldByYearData(this.analysis.uuid, this.harvestSeason, this.cropType);
    } finally {
      this.$emit('update:loading', false);
    }
  }

  get fetchKey() {
    return `${this.harvestSeason}:${this.cropType}`;
  }

  @Watch('fetchKey')
  private async onFetchKeyChange() {
    await this.loadChart();
  }

  get getYieldByYearList() {
    return this.$store.state.analyses.yieldByYearContext;
  }
}
